<template>
    <!-- 附件 弹框 -->
    <el-dialog
        class="net-task-attachment-view receiptSignattachment"
        :title="titleName"
        :visible="true"
        :before-close="closeDialogOnly"
        width="60%"
    >
        <div class="carryBox" v-loading="loading">
            <div class="attachment-view-left">
                <div class="attachmentTitle">
                    <el-row :gutter="20">
                        <el-col :span="13">
                            <div class="grid-content bg-purple">
                                <span>上传人：{{updateUserName}}</span>
                            </div>
                        </el-col>
                        <el-col :span="11">
                            <div class="grid-content bg-purple">
                                <span>上传时间：{{updateTime}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="this.imageType === '16'" class="breakage">
                        <el-col :span="13">
                            <div class="grid-content bg-purple">
                                <span>破损程度：{{damaged}}</span>
                            </div>
                        </el-col>
                        <el-col :span="11">
                            <div class="grid-content bg-purple">
                                <span>破损详情：{{damagedDetail}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="this.imageType === '16'" class="breakage">
                        <el-col :span="14">
                            <div class="grid-content bg-purple">
                                <span>破损备注：{{damagedRemark}}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="attachmentLeft">
                    <div class="viewerBox" v-show="imgArrType.length">
                        <ul id="viewers">
                            <li v-for="(item, index) in imgArrType" :key="index">
                                <img :src="item.imageUrl">
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="emptyImgBox" v-show="!imgArrType.length">
                    <i class="el-icon-picture"></i>
                </div>
                <div class="uploader" v-show="imageType">
                    <upload-new-btn
                        ref="attachmentUpload"
                        type="btn"
                        multiple
                        businessKey="default"
                        bucket="c-tms"
                        contentType="application/octet-stream"
                        :needBtn="false"
                        :publicRead="1"
                        :compressImage="true"
                        :compressQuality="0.5"
                        @beforeUpload="onBeforeUpload"
                        @callback="uploadResponse"
                    >
                        <i class="el-icon-plus pictures"></i>
                    </upload-new-btn>
                    <el-popover
                            placement="bottom"
                            width="160"
                            v-show="imgArrType.length > 1"
                            v-model="confirmVisible"
                            trigger="click">
                        <p> <i class="el-icon-info" style="color:red"></i> 确定删除当前图片？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button type="text" size="mini" @click="confirmVisible = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="deleteBtn">确定</el-button>
                        </div>
                        <i class="el-icon-delete smallBtn" slot="reference"></i>
                    </el-popover>
                    <i class="el-icon-download smallBtn" @click="downloadBtn" v-show="imgArrType.length !== 0"></i>
                </div>
            </div>
            <div class="attachment-view-right">
                <el-badge
                    :value="imgArr['1'].length"
                    class="badgeItem"
                    :hidden="!imgArr['1'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('1')"
                        :type="imageType === '1' ? 'primary' : ''"
                        >网点签收</el-button>
                </el-badge>
                <el-badge
                    v-if="rowData.businessMode === 'B2B'"
                    :value="imgArr['2'].length"
                    class="badgeItem"
                    :hidden="!imgArr['2'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('2')"
                        :type="imageType === '2' ? 'primary' : ''"
                        >用户签收</el-button>
                </el-badge>
                <el-badge
                    v-if="rowData.orderType === 'HT'"
                    :value="imgArr['3'].length"
                    class="badgeItem"
                    :hidden="!imgArr['3'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('3')"
                        :type="imageType === '3' ? 'primary' : ''"
                        >网点入库</el-button>
                </el-badge>
                <el-badge
                    v-if="rowData.orderType === 'HT'"
                    :value="imgArr['4'].length"
                    class="badgeItem"
                    :hidden="!imgArr['4'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('4')"
                        :type="imageType === '4' ? 'primary' : ''"
                        >网点出库</el-button>
                </el-badge>
                <el-badge
                    v-if="rowData.businessMode === 'B2C'"
                    :value="imgArr['5'].length"
                    class="badgeItem"
                    :hidden="!imgArr['5'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('5')"
                        :type="imageType === '5' ? 'primary' : ''"
                        >用户签收</el-button>
                </el-badge>
                <el-badge
                    v-if="rowData.businessMode === 'B2C'"
                    :value="imgArr['6'].length"
                    class="badgeItem"
                    :hidden="!imgArr['6'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('6')"
                        :type="imageType === '6' ? 'primary' : ''"
                        >用户拒签</el-button>
                </el-badge>
                <el-badge
                    v-if="rowData.businessMode === 'B2C'"
                    :value="imgArr['8'].length"
                    class="badgeItem"
                    :hidden="!imgArr['8'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('8')"
                        :type="imageType === '8' ? 'primary' : ''"
                        >上门取件</el-button>
                </el-badge>
                <el-badge
                    v-if="rowData.businessMode === 'B2B'"
                    :value="imgArr['9'].length"
                    class="badgeItem"
                    :hidden="!imgArr['9'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('9')"
                        :type="imageType === '9' ? 'primary' : ''"
                    >电子签收</el-button>
                </el-badge>
                <el-badge
                    v-if="rowData.businessMode === 'B2C'"
                    :value="imgArr['10'].length"
                    class="badgeItem"
                    :hidden="!imgArr['10'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('10')"
                        :type="imageType === '10' ? 'primary' : ''"
                        >远程费用</el-button>
                </el-badge>
                <el-badge
                    v-if="rowData.businessMode === 'B2C'"
                    :value="imgArr['16'].length"
                    class="badgeItem"
                    :hidden="!imgArr['16'].length"
                    type="primary"
                >
                    <el-button
                        class="right-btn"
                        @click="branchSignType('16')"
                        :type="imageType === '16' ? 'primary' : ''"
                        >破损签收</el-button>
                </el-badge>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import api from '../../../../api/netTaskManage2c.js';
import UploadNewBtn from '@/components/lots/OSS/UploadNewBtn';

export default {
    components: {
        UploadNewBtn
    },
    props: {
        rowData: {
            type: Object,
            default() {
                return {};
            }
        },
        titleName: {
            type: String,
            default: '附件查看'
        },
        onBeforeUpload: {
            type: Function
        }
    },
    data() {
        return {
            loading: false,
            confirmVisible: false,
            viewer: {},
            carouselIndex: 0, // 轮播图当前的索引
            imgArr: {},
            updateUserName: '',
            updateTime: '',
            damaged: '',
            damagedDetail: '',
            damagedRemark: '',
            branchSignImages: [],
            terminalSignImages: [],
            outboundImages: [],
            serviceImages: [],
            imgArrType: [],
            imageType: '',
            damagedList: {
                0: '正常',
                10: '轻微破损',
                20: '中度破损',
                30: '严重破损'

            }
        };
    },
    methods: {
        async getImgList() {
            this.loading = true;
            this.imgArr = {
                1: [],
                2: [],
                3: [],
                4: [],
                5: [],
                6: [],
                8: [],
                9: [],
                10: [],
                11: [],
                16: []
            };
            const params = {
                orderNo: this.rowData.orderNo,
                pageNo: 1,
                pageSize: 1000
            };
            if (!this.rowData.orderNo) {
                this.loading = false;
                return;
            }
            await api
                .orderImages(params)
                .then((res) => {
                    const list = res.data.list;
                    list.forEach((item) => {
                        if (item.type && item.imageUrl) this.imgArr[item.type].unshift(item);
                    });
                })
                .catch(() => {
                    this.closeDialogOnly();
                });
            await this.branchSignType(this.imageType || '1');
            this.loading = false;
        },
        branchSignType(type) {
            this.imageType = type;
            this.$emit('typeChange', type);
            if (this.viewer.images) this.viewer.destroy();
            this.imgArrType = this.imgArr[type];
            this.initShow();
        },
        async uploadResponse(response) {
            const params = {
                orders: [this.rowData.orderNo],
                type: this.imageType
            };
            params.images = response.map((item) => item.data.downUrl);
            await api.netUpload(params)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.$message.success('上传成功');
                        this.updateImgList();
                    }
                })
                .catch(() => {});
            this.$refs.attachmentUpload.$refs.ossElUpload.clearFiles();
            this.loading = false;
        },
        updateViewer() {
            this.carouselIndex = 0;
            this.updateInfo();
            this.updateImgList();
            this.viewer.destroy();
            setTimeout(() => {
                this.initViewer();
            });
        },
        // 删除图片
        async deleteBtn() {
            this.loading = true;
            const imageId = this.imgArrType[this.carouselIndex].id;
            await api
                .delImages(imageId)
                .then((res) => {
                    if (res) {
                        this.$message.success('删除成功');
                        this.updateViewer();
                    }
                })
                .catch(() => {
                    this.$message.error('删除失败');
                });
            this.confirmVisible = false;
            this.loading = false;
        },
        downloadBtn() {
            window.location =
                this.imgArrType[this.carouselIndex].imageUrl;
        },
        updateInfo() {
            const idx = this.carouselIndex;
            this.updateUserName = this.imgArrType[idx].updateUserName;
            this.updateTime = this.imgArrType[idx].updateTime;
            if (this.imageType === '16' && this.imgArrType[idx].damaged) {
                this.damaged = this.damagedList[+this.imgArrType[idx].damaged];
                this.damagedDetail = this.imgArrType[idx].damagedDetail;
                this.damagedRemark = this.imgArrType[idx].damagedRemark;
            }
        },
        async updateImgList() {
            if (this.viewer.images) this.viewer.destroy();
            await this.getImgList();
        },
        initViewer() {
            this.loading = true;
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: true,
                button: true,
                view: (info) => {
                    this.carouselIndex = info.detail.index;
                    this.updateInfo();
                },
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: barOptions,
                    reset: barOptions,
                    next: barOptions,
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
            this.loading = false;
        },
        initShow() {
            this.carouselIndex = 0;
            this.updateUserName = this.imgArrType.length ? this.imgArrType[0].updateUserName : '';
            this.updateTime = this.imgArrType.length ? this.imgArrType[0].updateTime : '';
            if (this.imageType === '16' && this.imgArrType.length && this.imgArrType[0].damaged) {
                this.damaged = this.imgArrType.length ? this.damagedList[+this.imgArrType[0].damaged] : '';
                this.damagedDetail = this.imgArrType.length ? this.imgArrType[0].damagedDetail : '';
                this.damagedRemark = this.imgArrType.length ? this.imgArrType[0].damagedRemark : '';
            }

            this.$nextTick(() => {
                this.initViewer();
            });
        },
        closeDialogOnly() {
            this.$emit('closeDialog', 'netAttachmentShow', false);
        }
    },
    created() {
        this.getImgList();
    },
    computed: {
        ...mapState({ user: (state) => state.user })
    }
};
</script>

<style lang="less">

.net-task-attachment-view {
    .viewerBox {
        height: 350px;
        #viewers {
            display: none;
        }
    }
    .carryBox {
        display: flex;
        height: 445px;
        flex-flow: row;
        .emptyImgBox {
            width: 100%;
            height: 350px;
            line-height: 350px;
            font-size: 350px;
            text-align: center;
            color: #00bcbf;
        }
    }
    .attachmentTitle {
        margin: 10px 0;
        .breakage{
            margin: 10px 0;
        }
    }
    .attachmentLeft {
        position: relative;
        .carousel {
            text-align: center;
            .receiveImgs {
                height: 100%;
            }
        }
        .viewer-backdrop.viewer-fixed {
            background-color: rgba(0, 0, 0, 0.5);
        }
        .viewer-backdrop {
            background-color: #fff;
        }
        .viewer-backdrop.viewer-fixed {
            background-color: rgba(0, 0, 0, 0.5);
        }
        .viewer-button {
            width: 60px;
            height: 60px;
            top: -30px;
            right: -30px;
        }
        .viewer-button::before {
            bottom: 10px;
            left: 10px;
        }
        .viewer-button.viewer-fullscreen-exit {
            width: 80px;
            height: 80px;
            top: -40px;
            right: -40px;
        }
        .viewer-button.viewer-fullscreen-exit::before {
            bottom: 15px;
            left: 15px;
        }
        .viewer-toolbar > ul > .viewer-small {
            margin: 3px;
        }
    }
    .uploader {
        padding: 15px 0 20px 0;
        text-align: center;

        > div {
            display: inline-block;
        }
        .pictures {
            border-radius: 4px;
            border: 1px dashed #00bcbf;
            color: #00bcbf;
            width: 20px;
            line-height: 20px;
        }
        .smallBtn {
            cursor: pointer;
            color: #00bcbf;
            font-size: 22px;
            vertical-align: middle;
            margin-left: 30px;
        }
        .el-upload{
            text-align: center;
        }
    }
    .attachment-view-left {
        flex: 1;
        padding-right: 16px;
    }
    .attachment-view-right {
        width: 120px;
        display: block;
        border-left: 2px solid #ccc;
        .badgeItem {
            width: 100%;
            margin: 10px auto;
            text-align: center;
        }
        .el-badge__content {
            right: 30px;
        }
    }
}
</style>
